import './image-slider.scss';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

class ImageSlider {
    constructor (element) {
        this.$slider = element;
        this.$range = element.querySelector('[data-image-slider="slider-pagination__range"]');
        this.$indicator = element.querySelector('[data-image-slider="slider-pagination-range-indicator"]');
        this.slider = null;
    }

    init () {
        this.initSlider();
    }

    initSlider () {
        this.slider = new Swiper(this.$slider, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            speed: 500,
            // indicatorsInControls: false,
            pagination: {
                el: '.slider-pagination',
                type: 'custom',
                renderCustom: (swiper, current, total) => {
                    return '<span class="current">0' + current + '</span><span class="total">  ' + '0' + total + '</span><div class="slider-pagination__range" data-image-slider="slider-pagination__range"><span class="slider-pagination-range-indicator" data-image-slider="slider-pagination-range-indicator"></span></div>';
                }
            },
            navigation: {
                nextEl: '.slider-button-next',
                prevEl: '.slider-button-prev'
            },
            on: {
                slideChange: () => {
                    this.handleRange();
                }
            }
        });

        this.handleRange();
    }

    handleRange (current, total) {
        this.$range = this.$slider.querySelector('[data-image-slider="slider-pagination__range"]');
        this.$indicator = this.$slider.querySelector('[data-image-slider="slider-pagination-range-indicator"]');

        this.$range = this.$slider.querySelector('[data-image-slider="slider-pagination__range"]');
        this.$indicator.style.width = 'calc(100% / ' + (this.slider.slides.length / (this.slider.activeIndex + 1)) + ')';
    }
}

export { ImageSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $imageSlider = $context.querySelectorAll('[data-image-slider="root"]');
        for (let i = 0; i < $imageSlider.length; i++) {
            const $slider = new ImageSlider($imageSlider[i]);
            $slider.init($imageSlider[i]);
        }
    }
});
